// extracted by mini-css-extract-plugin
export default {"forenotice":"index_forenotice_BgYvV"};